<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M8 3c.5-.6 1.5-.6 2 0l8 8c.6.5.6 1.5 0 2l-8 8a1.5 1.5 0 1 1-2-2l6.9-7-7-7c-.5-.5-.5-1.5 0-2"
    />
  </svg>
</template>
